import { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import axiosAdmin from "../../../../api/apiAdmin";
import FlightsItem from "./FlightsItem";
import { successToast, errorToast } from "../../toastAlerts/ToastAlerts";
import {
  TextInput,
  SelectInputValueId,
  DateInput,
} from "../../inputComponents/inputcomp";
import { AdminPrimaryContext } from "../../adminContext/AdminContext";
import { BsSearch } from "react-icons/bs";
import PaginatedItems from "../../Pagination/Pagination";
import { apiError } from "../../../../api/apiError";

const Flights = () => {
  const { t } = useTranslation();

  const statusses = [
    {
      name: t("admin_not_started"),
      value: 1,
    },
    {
      name: t("admin_on_the_way"),
      value: 2,
    },
    {
      name: t("admin_has_arrived"),
      value: 3,
    },
  ];

  const types = [
    {
      name: t("admin_cargo"),
      value: 1,
    },
    {
      name: t("admin_airplane"),
      value: 2,
    },
    {
      name: t("admin_ship"),
      value: 3,
    },
  ];
  const [addNewToggler, setAddNewToggler] = useState(false);
  const [flightsData, setFlightsData] = useState([]);
  const [difResponses, setDifResponses] = useState(null);
  const [newflights, setNewFlights] = useState({});
  const [makeEmpty, setMakeEmpty] = useState(false);
  const { abOffices, countries } = useContext(AdminPrimaryContext);
  const [officeOptions, setOfficeOptions] = useState([]);
  const [total, setTotal] = useState(0);
  const [filterShipments, setFilterShipments] = useState({
    page: 0,
    perPage: 30,
  });
  const [countriesOptions, setCountriesOptions] = useState([]);

  const handleFliters = (value, key) => {
    setFilterShipments((prev) => ({ ...prev, [key]: value }));
  };

  //handle filed clear after submission
  const handleMakeEmpty = (value) => {
    setMakeEmpty(value);
  };

  //handle new flights
  const handleNewFlightsData = (value, inputName) => {
    setNewFlights((prev) => ({ ...prev, [inputName]: value }));
  };

  //add new users handlers
  const handleAddNewToggle = (value) => {
    setAddNewToggler(value);
  };

  //add new flights
  const handleAddNewFlightsToDb = async () => {
    try {
      const res = await axiosAdmin.post(`/shipments`, newflights);
      setDifResponses(res);
      if (res) {
        successToast(t("admin_data_added_success"));
        handleMakeEmpty(true);
      }
    } catch (error) {
      errorToast(apiError(error, t("admin_error_try_again")));
    }
  };

  //delete flights
  const handleDeleteFlights = async (id) => {
    try {
      const res = await axiosAdmin.delete(`/shipments/${id}`);
      setDifResponses(res);
      if (res) {
        successToast(t("admin_data_deleted_success"));
      }
    } catch (error) {
      errorToast(apiError(error, t("admin_error_try_again")));
    }
  };

  //flights data from api
  useEffect(() => {
    axiosAdmin
      .get(`/shipments`, {
        params: {
          page: filterShipments.page + 1,
          per_page: filterShipments.perPage,
          key: filterShipments.key,
          shipment_status: filterShipments.shipment_status,
          country_id: filterShipments.country_id,
          abroad_office_id: filterShipments.abroad_office_id,
          type: filterShipments.type,
        },
      })
      .then(({ data }) => {
        setFlightsData(data.data);
        setTotal(data.total);
      })
      .then(() => {});
  }, [difResponses, filterShipments]);

  const handleClear = () => {
    setFilterShipments({
      page: 0,
      perPage: 30,
    });
  };

  //country
  useEffect(() => {
    const tmp = abOffices.map((item) => {
      return { name: item.country, value: item.id };
    });
    setOfficeOptions(tmp);
  }, [abOffices]);

  useEffect(() => {
    const tmp = countries.map((item) => {
      return { name: item.name, value: item.id };
    });
    setCountriesOptions(tmp);
  }, [countries]);

  return (
    <div
      className="xl:ml-[280px] mt-[55px] bg-slate-100 dark:bg-slate-900 
            min-h-screen p-10 sm:p-5 pb-24 sm:pb-24"
    >
      <div className="w-full flex flex-col gap-5 pb-10 sm:pb-5">
        <div className="w-full justify-end flex">
          <button
            onClick={() => {
              handleAddNewToggle(true);
            }}
            className="w-3/12 md:w-full rounded-lg p-3 text-white text-sm bg-violet-400 mx-5 sm:mx-0"
          >
            {t("admin_add_new_flight")}
          </button>
        </div>

        <div className="grid grid-cols-4 gap-2">
          <TextInput
            name={t("admin_search_keyword")}
            inputName={"key"}
            inputSetter={handleFliters}
            value={filterShipments.key}
          />
          <SelectInputValueId
            name={t("admin_status")}
            options={statusses}
            inputName={"shipment_status"}
            inputSetter={handleFliters}
            value={filterShipments.shipment_status}
          />
          <SelectInputValueId
            name={t("admin_flight_type")}
            options={types}
            inputName={"type"}
            inputSetter={handleFliters}
            value={filterShipments.type}
          />
          <SelectInputValueId
            name={t("admin_country")}
            options={countriesOptions}
            inputName={"country_id"}
            inputSetter={handleFliters}
            value={filterShipments.country_id}
          />
          <SelectInputValueId
            name={t("admin_office")}
            inputName={"abroad_office_id"}
            inputSetter={handleFliters}
            options={officeOptions}
            value={filterShipments.abroad_office_id}
          />
          <div
            onClick={handleClear}
            className="rounded-lg bg-red-400
                 flex items-center justify-center p-1 py-3 cursor-pointer self-end"
          >
            <span className="text-sm text-white ">{t("admin_clear")}</span>
          </div>
        </div>
        {addNewToggler && (
          <div className="bg-slate-100 dark:bg-slate-900 ">
            <div className="sm:px-0">
              <div className="w-full rounded-xl bg-white dark:bg-slate-700 p-5">
                <div className="flex items-center justify-between flex-wrap gap-5">
                  <div className="flex items-center gap-5 sm:gap-3 ">
                    <div>
                      <h2
                        className="text-xl text-slate-400 font-bold dark:text-gray-400
                            sm:text-[16px] smd:text-[16px]"
                      >
                        {t("admin_add_new_flight")}
                      </h2>
                    </div>
                  </div>
                  <div className="flex gap-2 sm:w-full">
                    <button
                      onClick={handleAddNewFlightsToDb}
                      className="rounded-lg p-3 text-white text-sm bg-violet-400 sm:w-full"
                    >
                      {t("admin_save")}
                    </button>
                    <button
                      onClick={() => {
                        handleAddNewToggle(false);
                      }}
                      className="rounded-lg p-3 text-white text-sm bg-red-400 w-10"
                    >
                      X
                    </button>
                  </div>
                </div>
                <div className="pt-5 flex gap-5 md:flex-col md:gap-0 sm:flex-col sm:gap-0">
                  <div className="w-6/12 sm:w-full md:w-full">
                    <SelectInputValueId
                      name={t("admin_office")}
                      inputName={"abroad_office_id"}
                      inputSetter={handleNewFlightsData}
                      options={officeOptions}
                    />
                    <SelectInputValueId
                      name={t("admin_status")}
                      inputName={"status"}
                      inputSetter={handleNewFlightsData}
                      options={statusses}
                    />
                  </div>
                  <div className="w-6/12 sm:w-full md:w-full">
                    <TextInput
                      name={t("admin_description")}
                      inputName={"description"}
                      inputSetter={handleNewFlightsData}
                      makeEmpty={makeEmpty}
                      handleMakeEmpty={handleMakeEmpty}
                    />
                    <DateInput
                      name={t("admin_arrival_approx_time")}
                      inputSetter={handleNewFlightsData}
                      inputName={"estemated_date"}
                      makeEmpty={makeEmpty}
                      handleMakeEmpty={handleMakeEmpty}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <PaginatedItems
        pageNumberSetter={(page) => {
          setFilterShipments((prev) => ({ ...prev, page }));
        }}
        dataLength={total}
      >
        <div className="grid grid-cols-3 md:grid-cols-2  sm:grid-cols-1 sm:pt-5 gap-2 my-5">
          {flightsData.map((item) => {
            return (
              <FlightsItem
                key={item.id}
                item={item}
                id={item.id}
                handleDeleteFlights={handleDeleteFlights}
              />
            );
          })}
        </div>
      </PaginatedItems>
    </div>
  );
};

export default Flights;
